import type { PropsWithChildren } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/app/query-client'
import { MemberLoginPopupQueue } from '@/widgets/member-login-popups/MemberLoginPopupQueue'
import { ThemeProvider } from './ThemeProvider'

export function AppProviders({ children }: PropsWithChildren) {
  return <QueryClientProvider client={queryClient}><ThemeProvider>{children}<MemberLoginPopupQueue /></ThemeProvider></QueryClientProvider>
}
